<template>
    <div class="clueDetailsBox">
        <el-tabs v-model="activeName">
            <!--            基本信息-->
            <el-tab-pane label="基本信息" name="first">
                <basicInfo style="margin: 20px 0px" v-if="activeName === 'first'"></basicInfo>
            </el-tab-pane>
<!--            跟进记录-->
<!--            <el-tab-pane label="跟进记录" name="second">-->
<!--                <followUpRecord style="margin: 20px 0px" v-if="activeName === 'second'"></followUpRecord>-->
<!--            </el-tab-pane>-->
            <!--            通话记录-->
            <el-tab-pane label="通话记录" name="third">
                <callLog  v-if="activeName === 'third'"></callLog>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import basicInfo from '@/views/callCenter/components/basicInfo.vue';
import followUpRecord from '@/views/callCenter/components/followUpRecord.vue';
import callLog from '@/views/callCenter/components/callLog.vue';

export default {
    name: 'clueDetails',
    components:{
        basicInfo,
        followUpRecord,
        callLog
    },
    data() {
        return {
            activeName: 'first',
        };
    },
    methods: {

    },
}
</script>

<style scoped lang="scss">
    ::v-deep .el-tabs__header{
        margin:0px
    }
    .clueDetailsBox{
        padding: 10px;
        //background-color: #fff;
        //border-radius: 5px;
    }
     ::v-deep .el-tabs__nav-wrap::after {
        background-color: transparent ;
    }

    ::v-deep .el-tabs__item {
        padding: 0px 30px;
    }
    ::v-deep .el-tabs__nav-scroll{
        padding: 10px;
        border-radius: 5px 5px 0px 0px;
        background-color: #fff;
    }
    ::v-deep .el-tabs__nav{
        margin-left: 15px;
    }
</style>